<template>
  <div class="AdminPickingOCListSixten">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ picking }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">{{ ocList }}</router-link>
      </li>
    </ol>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane nopadding active" id="tabOCList" role="tabpanel">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <bootstrapTable
                    :configurations="tableOCListConfiguration"
                    :datas="tableOCListData"
                    id="tableOCList"
                    :onClickRow="onClickOCList"
                    ref="tableOCList"
                  ></bootstrapTable>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabItemList" role="tabpanel">
            <div class="card-body onlyMobile">
              <div class="row">
                <div class="col">
                  <button
                    id="btnItemListBack"
                    type="button"
                    class="btn btn-primary"
                    @click="goToStartReading"
                  >
                    <i class="fa fa-barcode"></i>
                    <span>{{ startReading }}</span>
                  </button>
                </div>
                <div class="col text-right">
                  <button
                    id="btnItemListBack"
                    type="button"
                    class="btn btn-danger"
                    @click="itemListBack"
                  >
                    <i class="fa fa-chevron-left"></i>
                    <span>{{ cancel }}</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="card-header">
              <div class="row">
                <div class="col">
                  <b>{{ customer }}</b>
                </div>
                <div class="col text-right">
                  <b>{{ order }}</b>
                </div>
              </div>
              <div class="row">
                <div class="col">{{ customerSelected }}</div>
                <div class="col text-right">{{ orderSelected }}</div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">&nbsp;</div>
              <div class="row">
                <div class="col text-right">{{ toEscape }}</div>
                <div class="col align-self-center">
                  <label
                    class="switch switch-pill switch-primary"
                    style="margin:2px; vertical-align:bottom;"
                  >
                    <input
                      type="checkbox"
                      class="switch-input"
                      v-model="chkToEscape"
                      true-value="yes"
                      false-value="no"
                    />
                    <span class="switch-slider" data-on data-off></span>
                  </label>
                </div>
              </div>
              <div class="row">&nbsp;</div>
              <div class="row">
                <div class="col-sm-12">
                  <bootstrapTable
                    :configurations="tableItemListConfiguration"
                    :datas="tableItemListData"
                    :filterBy="tableItemListFilterBy"
                    id="tableItemList"
                    ref="tableItemList"
                  ></bootstrapTable>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">&nbsp;</div>
              </div>
              <div class="row">
                <div class="col text-right">
                  <button
                    id="btnItemListBack"
                    type="button"
                    class="btn btn-primary btn-block"
                    @click="goToStartReading"
                  >
                    <i class="fa fa-barcode"></i>
                    <span>{{ startReading }}</span>
                  </button>
                  <button
                    id="btnItemListBack"
                    type="button"
                    class="btn btn-danger btn-block"
                    @click="itemListBack"
                  >
                    <i class="fa fa-chevron-left"></i>
                    <span>{{ cancel }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";

export default {
  name: "AdminPickingOCListSixten",
  components: {
    BootstrapTable
  },
  data() {
    return {
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      chkToEscape: "no",
      customer: dictionaryHelpers.getDictionary("Customer"),
      customerSelected: "",
      idSelected: 0,
      idHeadSeleted: 0,
      idTabItemList: "tabItemList",
      idTabOCList: "tabOCList",
      ocList: dictionaryHelpers.getDictionary("OCList"),
      order: dictionaryHelpers.getDictionary("Order"),
      orderSelected: "",
      picking: dictionaryHelpers.getDictionary("Picking"),
      startReading: dictionaryHelpers.getDictionary("StartReading"),
      tableItemListConfiguration: [],
      tableItemListData: [],
      tableItemListFilterBy: {},
      tableOCListConfiguration: [],
      tableOCListData: [],
      toEscape: dictionaryHelpers.getDictionary("ToEscape"),
      url: window.location.pathname
    };
  },
  watch: {
    chkToEscape: function(newVal, oldVal) {
      if (newVal == "yes") {
        this.tableItemListFilterBy = { pickingState: [0, 1] };
      } else {
        this.tableItemListFilterBy = "";
      }
    },
    $route(to, from) {
      if (!functionHelpers.isValued(to.params.id)) {
        this.loadOCListTableData();
        $("#" + this.idTabOCList).addClass("active");
        $("#" + this.idTabItemList).removeClass("active");
      }
    }
  },
  created() {
    spinnerHelpers.show();
    this.loadConfiguration();
  },
  methods: {
    /***   OC LIST   ***/

    loadConfiguration() {
      var adminSettingUser = this;

      adminConfigurationServices.getFunctionality(function(result) {
        if (
          functionHelpers.isValued(result) &&
          functionHelpers.isValued(result.data) &&
          functionHelpers.isValued(result.data)
        ) {
          adminSettingUser.tableOCListConfiguration =
            result.data.tablesConfigurations[0].tablesConfigurations;
          adminSettingUser.tableItemListConfiguration =
            result.data.tablesConfigurations[1].tablesConfigurations;
        }
        adminSettingUser.loadOCListTableData();
      });
    },
    loadOCListTableData() {
      var adminSettingUser = this;
      documentHeadServices.getSixtenOrderConfirmed(function(result) {
        adminSettingUser.tableOCListData = result.data;
        spinnerHelpers.hide();
      });
    },
    onClickOCList(row, element, field) {
      spinnerHelpers.show();
      this.idSelected = row.id;
      this.customerSelected = row.customerDescription;
      this.orderSelected = row.orderNumber;
      this.chkToEscape = "yes";
      this.loadItemTableData();
      $("#" + this.idTabOCList).removeClass("active");
      $("#" + this.idTabItemList).addClass("active");
      this.$router.push({ path: `/admin/picking/OCList/${this.idSelected}` });
    },

    /***   END OC LIST   ***/

    /***   ITEM LIST   ***/

    loadItemTableData() {
      var adminSettingUser = this;
      documentRowServices.getSixtenByHead(this.idSelected, function(result) {
        adminSettingUser.tableItemListData = result.data;
        spinnerHelpers.hide();
      });
    },
    pickingStateFormatter(value, row, index, field) {
      switch (row.pickingState) {
        case 0:
          return '<div class="text-center"><i class="fa fa-times-circle error"></i></div>';
          break;

        case 1:
          return '<div class="text-center"><i class="fa fa-exclamation-triangle warning"></i></div>';
          break;

        case 2:
          return '<div class="text-center"><i class="fa fa-check-circle success"></i></div>';
          break;
      }
    },
    goToStartReading() {
      // this.$router.push({ path: `/admin/picking/reading/${this.idSelected}/${this.orderSelected}` });
      this.$router.push({ path: `/admin/picking/reading` });
    },
    itemListBack() {
      spinnerHelpers.show();
      $("#" + this.idTabOCList).addClass("active");
      $("#" + this.idTabItemList).removeClass("active");
      this.customerSelected = "";
      this.orderSelected = "";
      this.$router.push({ path: `/admin/picking/OCList` });
      spinnerHelpers.hide();
    }

    /***   END ITEM LIST   ***/
  }
};
</script>

<style>
@media (min-width: 992px) {
  .btn-block {
    display: inline-block;
    width: auto;
    margin-top: 0rem !important;
  }
}
</style>
